import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../../modules/auth/services/auth.service';
import {SETTINGS} from "../config/common.settings";

@Injectable()
export class LoginGuard {
  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) {
      if (this.authService.getLoggedInUser().userType === SETTINGS.USERS.ADMIN) {
        this.router.navigate(['/admin']);
      } else if (this.authService.getLoggedInUser().userType === SETTINGS.USERS.MEMBER) {
        this.router.navigate(['/member']);
      } else {
        this.router.navigate(['']);
      }
      return false;
    } else {
      return true;
    }
  }
}
